import {
  CONTENT_MODAL_MODE_LINK,
  CONTENT_MODAL_MODE_MANUAL,
  SET_CONTENT_MODAL_ID,
  SET_CONTENT_MODAL_IS_VISIBLE,
  SET_CONTENT_MODAL_MODE
} from './types'

export const state = {
  id: null,
  isVisible: false,
  mode: CONTENT_MODAL_MODE_LINK
}

export const mutations = {
  [SET_CONTENT_MODAL_ID] (state, value) {
    state.id = value
  },
  [SET_CONTENT_MODAL_IS_VISIBLE] (state, value) {
    state.isVisible = value
  },
  [SET_CONTENT_MODAL_MODE] (state, value) {
    state.mode = value
  }
}

export const actions = {
  openContentModalLinkMode ({ commit, dispatch }) {
    commit(SET_CONTENT_MODAL_MODE, CONTENT_MODAL_MODE_LINK)
    dispatch('prepareContentModal')
    .then(() => dispatch('contentForm/prefill'))
    .then(() => commit(SET_CONTENT_MODAL_IS_VISIBLE, true))
  },
  openContentModalManualMode ({ commit, dispatch }) {
    commit(SET_CONTENT_MODAL_MODE, CONTENT_MODAL_MODE_MANUAL)
    dispatch('prepareContentModal')
      .then(() => dispatch('contentForm/prefill'))
      .then(() => commit(SET_CONTENT_MODAL_IS_VISIBLE, true))
  },
  openContentModalContent ({ commit, dispatch }, contentId) {
    return dispatch('prepareContentModal')
      .then(() => commit(SET_CONTENT_MODAL_ID, contentId))
      .then(() => commit(SET_CONTENT_MODAL_MODE, CONTENT_MODAL_MODE_MANUAL))
      .then(() => dispatch('contentForm/show', { contentId }, { root: true }))
      .then(() => dispatch('contentForm/prefill'))
      .then(() => commit(SET_CONTENT_MODAL_IS_VISIBLE, true))
  },
  closeContentModal ({ commit, dispatch }) {
    commit(SET_CONTENT_MODAL_ID, null)
    commit(SET_CONTENT_MODAL_IS_VISIBLE, false)
    dispatch('contentForm/reset')
  },
  prepareContentModal ({ dispatch }) {
    return Promise.all([
      dispatch('fetchCountries'),
      dispatch('fetchWritableFolders'),
      dispatch('fetchTags'),
    ])
  }
}

export const getters = {
  contentModalIsLinkMode ({ mode }) {
    return mode === CONTENT_MODAL_MODE_LINK
  },
  contentModalIsManualMode ({ mode }) {
    return mode === CONTENT_MODAL_MODE_MANUAL
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/contents/contentModal.js